/** ai大赛 */
export const aiCompetition = [
  {
    name: 'getCompetitionList', // AI大赛列表
    isMock: false,
  },
  {
    name: 'getCompetitionProductList', // 单个大赛：投稿作品列表
    isMock: false,
  },
  {
    name: 'getCompetitionDetail', // 单个大赛：后台配置的详情
    isMock: false,
  },
  {
    name: 'getCompetitionDataStats', // 单个大赛：数据统计
    isMock: false,
  },
  {
    name: 'getCompetitionNews', // 单个大赛：报导列表
    isMock: false,
  },
  {
    name: 'getCompetitionProductDetail', // 单个投稿作品详情
    isMock: false,
  },
]
